import { render, staticRenderFns } from "./correctionSampleList.vue?vue&type=template&id=b704c15c"
import script from "./correctionSampleList.vue?vue&type=script&lang=js"
export * from "./correctionSampleList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports